import request from "@/utils/request";
import { getCurrentBusiness } from "@/utils/auth";

export function getSettings() {
  var url = "api/business/settings";
  var currentBusiness = getCurrentBusiness();

  if (currentBusiness != null) {
    url = url + "?currentBusinessId=" + currentBusiness.id;
  }

  return request({
    url: url,
    method: "get",
  });
}

export function handleAddSocialCalendar(code, data) {
  var url = "api/business/cronofy/calendar/profile?code=" + code;
  var currentBusiness = getCurrentBusiness();

  if (currentBusiness != null) {
    url = url + "&currentBusinessId=" + currentBusiness.id;
  }

  return request({
    url: url,
    method: "post",
    data,
  });
}

export function deleteCronofyProfile(id) {
  var url = "api/business/cronofy/calendar/profile?cronofy_profile_id=" + id;
  var currentBusiness = getCurrentBusiness();

  if (currentBusiness != null) {
    url = url + "&currentBusinessId=" + currentBusiness.id;
  }

  return request({
    url: url,
    method: "delete",
  });
}

export function getAllSocialAccounts() {
  var url = "api/business/cronofy/calendar/profiles";
  var currentBusiness = getCurrentBusiness();

  if (currentBusiness != null) {
    url = url + "?currentBusinessId=" + currentBusiness.id;
  }

  return request({
    url: url,
    method: "get",
  });
}

export function updateBusinessSettings(data) {
  var url = "api/business/settings";
  var currentBusiness = getCurrentBusiness();

  if (currentBusiness != null) {
    url = url + "?currentBusinessId=" + currentBusiness.id;
  }
  return request({
    url: url,
    method: "patch",
    data,
  });
}

export function updateLastMinPage(data) {
  var url = "api/business/last-min-info";
  var currentBusiness = getCurrentBusiness();

  if (currentBusiness != null) {
    url = url + "?currentBusinessId=" + currentBusiness.id;
  }
  return request({
    url: url,
    method: "patch",
    data,
  });
}

export function updateOwnerSettings(data) {
  var url = "api/business/owner-settings";
  var currentBusiness = getCurrentBusiness();

  if (currentBusiness != null) {
    url = url + "?currentBusinessId=" + currentBusiness.id;
  }

  return request({
    url: url,
    method: "patch",
    data,
  });
}

export function updateHoursSettings(data) {
  var url = "api/business/hours-settings";
  var currentBusiness = getCurrentBusiness();

  if (currentBusiness != null) {
    url = url + "?currentBusinessId=" + currentBusiness.id;
  }

  return request({
    url: url,
    method: "patch",
    data,
  });
}

export function updateHoursDisplaySettings(data) {
  var url = "api/business/hours-display-settings";
  var currentBusiness = getCurrentBusiness();

  if (currentBusiness != null) {
    url = url + "?currentBusinessId=" + currentBusiness.id;
  }

  return request({
    url: url,
    method: "patch",
    data,
  });
}

export function updateColorDisplaySettings(data) {
  var url = "api/business/color-display-settings";
  var currentBusiness = getCurrentBusiness();

  if (currentBusiness != null) {
    url = url + "?currentBusinessId=" + currentBusiness.id;
  }

  return request({
    url: url,
    method: "patch",
    data,
  });
}

export function getCalanderList(data) {
  var url = "api/business/calendars";
  var currentBusiness = getCurrentBusiness();

  if (currentBusiness != null) {
    url = url + "?currentBusinessId=" + currentBusiness.id;
  }

  return request({
    url: url,
    method: "get",
    data,
  });
}

// Persisted, provider-free status for the dashboard. The live calendar list above
// remains reserved for the settings replacement selector.
export function getCalendarSyncStatus() {
  var url = "api/business/calendar-sync/status";
  var currentBusiness = getCurrentBusiness();
  if (currentBusiness != null) {
    url = url + "?currentBusinessId=" + currentBusiness.id;
  }
  return request({ url: url, method: "get" });
}

// Both preview and execute hit the SAME endpoint; only the body `confirm` flag differs.
// cronofyProfileId MUST be the DB id (CalendarResponse.cronofyProfileId), not the external one.
function cronofyCalendarSwitch(cronofyProfileId, calendarId, confirm) {
  var url = "api/business/cronofy/calendar/switch";
  var currentBusiness = getCurrentBusiness();

  if (currentBusiness != null) {
    url = url + "?currentBusinessId=" + currentBusiness.id;
  }

  return request({
    url: url,
    method: "post",
    data: { cronofyProfileId: cronofyProfileId, calendarId: calendarId, confirm: confirm },
  });
}

export function previewCronofyCalendarSwitch(cronofyProfileId, calendarId) {
  return cronofyCalendarSwitch(cronofyProfileId, calendarId, false);
}

export function executeCronofyCalendarSwitch(cronofyProfileId, calendarId) {
  return cronofyCalendarSwitch(cronofyProfileId, calendarId, true);
}

// Safe disconnect: preview and execute hit the SAME endpoint; only `confirm` differs.
// Replaces the one-click DELETE so the operator sees manual-review / partial-failure
// states. cronofyProfileId MUST be the DB id.
function cronofyProfileDisconnect(cronofyProfileId, confirm) {
  var url = "api/business/cronofy/calendar/profile/disconnect";
  var currentBusiness = getCurrentBusiness();

  if (currentBusiness != null) {
    url = url + "?currentBusinessId=" + currentBusiness.id;
  }

  return request({
    url: url,
    method: "post",
    data: { cronofyProfileId: cronofyProfileId, confirm: confirm },
  });
}

export function previewCronofyDisconnect(cronofyProfileId) {
  return cronofyProfileDisconnect(cronofyProfileId, false);
}

export function executeCronofyDisconnect(cronofyProfileId) {
  return cronofyProfileDisconnect(cronofyProfileId, true);
}

// Operator purge: delete ALL orphaned mirrored (calendar-bound) entries left
// behind after a calendar was disconnected — any date, any non-DELETED status
// incl. CANCELLED. confirm=false previews ids, confirm=true deletes and returns
// affected ids.
function cronofyPurgeOrphaned(confirm) {
  var url =
    "api/business/cronofy/calendar/purge-orphaned-mirrored?confirm=" + confirm;
  var currentBusiness = getCurrentBusiness();

  if (currentBusiness != null) {
    url = url + "&currentBusinessId=" + currentBusiness.id;
  }

  return request({
    url: url,
    method: "post",
  });
}

export function previewPurgeOrphaned() {
  return cronofyPurgeOrphaned(false);
}

export function executePurgeOrphaned() {
  return cronofyPurgeOrphaned(true);
}

// Per-business notification matrix (event x recipient). GET returns the full
// matrix with defaults filled in; PUT upserts the given cells.
export function getNotificationSettings() {
  var url = "api/business/notification-settings";
  var currentBusiness = getCurrentBusiness();
  if (currentBusiness != null) {
    url = url + "?currentBusinessId=" + currentBusiness.id;
  }
  return request({ url: url, method: "get" });
}

export function updateNotificationSettings(cells) {
  var url = "api/business/notification-settings";
  var currentBusiness = getCurrentBusiness();
  if (currentBusiness != null) {
    url = url + "?currentBusinessId=" + currentBusiness.id;
  }
  return request({ url: url, method: "put", data: cells });
}



// WEBPACK FOOTER //
// ./src/api/business-settings.js